import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Brand */}
        <div className="footer-section footer-brand">
          <Link to="/" className="footer-logo">
            <div className="footer-logo-wrapper">
              <img src="/Zella logo white.png" alt="Zella" className="footer-logo-img" />
            </div>
          </Link>
          <p>Real-time fatigue management for modern workplaces. Keep your teams safe, happy and productive.</p>
        </div>

        {/* Product links */}
        <div className="footer-section">
          <h4>Product</h4>
          <button onClick={() => scrollToSection('about')}>About</button>
          <button onClick={() => scrollToSection('studies')}>Studies</button>
          <button onClick={() => scrollToSection('how-it-works')}>How It Works</button>
          <button onClick={() => scrollToSection('pricing')}>Pricing</button>
        </div>

        {/* Legal links */}
        <div className="footer-section">
          <h4>Terms</h4>
          <Link to="/terms/privacy-policy">Privacy Policy</Link>
          <Link to="/terms/terms-of-service">Terms of Service</Link>
          <Link to="/terms/acceptable-use">Acceptable Use Policy</Link>
          <Link to="/terms/cookie-policy">Cookie Policy</Link>
        </div>

        {/* Connect */}
        <div className="footer-section">
          <h4>Connect</h4>
          <a href="mailto:hello@zellawellbeing.com">hello@zellawellbeing.com</a>
          <a
            href="https://www.linkedin.com/company/zellawellbeing"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
            </svg>
            LinkedIn
          </a>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Zella. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/terms/privacy-policy">Privacy</Link>
          <Link to="/terms/terms-of-service">Terms</Link>
          <Link to="/terms/cookie-policy">Cookies</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
